import React from 'react';
import { Container, Form, Button, Card, Row, Col, ProgressBar } from 'react-bootstrap';
import '../components/components.css';

const AutoMastering = () => {
  return (
    <Container className="py-4 beats-component-container">
      <h2>Auto Mastering</h2>
      <p>Enhance your track with AI-powered mastering tools.</p>
      
      <Card className="my-4 p-4 beats-card">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Upload Audio File</Form.Label>
            <Form.Control type="file" accept="audio/*" className="beats-form-control" />
            <Form.Text className="text-muted beats-form-text">
              Supported formats: MP3, WAV, FLAC (max 20MB)
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label className="beats-form-label">Select Genre</Form.Label>
            <Form.Select aria-label="Select genre" className="beats-form-select">
              <option>Hip Hop</option>
              <option>Electronic</option>
              <option>Rock</option>
              <option>Pop</option>
              <option>R&B</option>
              <option>Classical</option>
              <option>Jazz</option>
              <option>Ambient</option>
            </Form.Select>
          </Form.Group>
          
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label className="beats-form-label">Loudness Target</Form.Label>
                <Form.Range min="-18" max="-6" step="1" defaultValue="-14" />
                <div className="d-flex justify-content-between">
                  <small className="beats-form-text">Quiet (-18 LUFS)</small>
                  <small className="beats-form-text">Loud (-6 LUFS)</small>
                </div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label className="beats-form-label">Bass Boost</Form.Label>
                <Form.Range min="0" max="10" defaultValue="5" />
                <div className="d-flex justify-content-between">
                  <small className="beats-form-text">None</small>
                  <small className="beats-form-text">Maximum</small>
                </div>
              </Form.Group>
            </Col>
          </Row>
          
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label className="beats-form-label">Clarity</Form.Label>
                <Form.Range min="0" max="10" defaultValue="5" />
                <div className="d-flex justify-content-between">
                  <small className="beats-form-text">Warm</small>
                  <small className="beats-form-text">Bright</small>
                </div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label className="beats-form-label">Stereo Width</Form.Label>
                <Form.Range min="0" max="10" defaultValue="5" />
                <div className="d-flex justify-content-between">
                  <small className="beats-form-text">Narrow</small>
                  <small className="beats-form-text">Wide</small>
                </div>
              </Form.Group>
            </Col>
          </Row>
          
          <Button variant="primary" type="submit" className="mb-3 beats-btn-primary">
            Start Mastering
          </Button>
          
          <div className="mt-3">
            <Form.Label className="beats-form-label">Processing</Form.Label>
            <ProgressBar animated now={45} label="45%" className="beats-progress" />
          </div>
        </Form>
      </Card>
    </Container>
  );
};

export default AutoMastering; 